import {
    CLEAR_ERROR,
    CLEAR_TEMPLATE_PRODUCTS,
    SET_PRODUCT_SEARCH_STATUS,
    SET_SURGERY_NUMBER,
    // SURGERY_RESET_PO_ATTACHMENT
} from './actionTypes';
import {
    SET_IMPLANT_AND_INSTRUMENT_PRODUCTS,
    SET_IMPLANT_PRODUCTS,
    SET_INSTRUMENT_PRODUCTS,
    SET_ITEM_LIST_CLICKED,
    SURGERY_RESET_PO_ATTACHMENT,
    GET_TRANSFER_RECIPIENT_METHODS,
    CLEAR_TRANSFER_RECIPIENTS,
    STORE_ADD_ITEM,
    CLEAR_ADD_ITEM,
} from './actionTypes';
import {
    CHECK_PRODUCT_BOM,
    RESET_BOM_DATA,
    DELETE_PRODUCT_BOM,
} from './actionTypes';
export const SET_SURGERY_DETAILS = 'SURGERY: SET_SURGERY_DETAILS';
export const SET_CART_DATA = 'SURGERY: SET_CART_DATA';
export const UPDATE_CART_DATA = 'SURGERY: UPDATE_CART_QUANTITY';
export const UPDATE_CART_DATA_SHIPPING = 'SURGERY: UPDATE_CART_DATA_SHIPPING';
export const SET_SHIPPING_DETAILS = 'SURGERY: SET_SHIPPING_DETAILS';
export const SET_SHIPPING_DETAILS_EDIT_MODE = 'SET_SHIPPING_DETAILS_EDIT_MODE';
export const SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
export const GET_DROPDOWN = 'SURGERY: GET_DROPDOWN';
export const GET_DROPDOWN_SUCCESS = 'SURGERY: GET_DROPDOWN_SUCCESS';
export const GET_DROPDOWN_FAILURE = 'SURGERY: GET_DROPDOWN_FAILURE';
export const SAVE_SURGERY_DETAILS = 'SURGERY: SAVE_SURGERY_DETAILS';
export const GET_SCHEDULE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: GET_SCHEDULE_SURGERY_DETAILS_SUCCESS';
export const GET_SCHEDULE_SURGERY_DETAILS_FAILURE =
    'SURGERY: GET_SCHEDULE_SURGERY_DETAILS_FAILURE';
export const SAVE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: SAVE_SURGERY_DETAILS_SUCCESS';
export const SAVE_SURGERY_DETAILS_FAILURE =
    'SURGERY: SAVE_SURGERY_DETAILS_FAILURE';
export const UPDATE_SURGERY_DETAILS = 'SURGERY: UPDATE_SURGERY_DETAILS';
export const UPDATE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: UPDATE_SURGERY_DETAILS_SUCCESS';
export const UPDATE_SURGERY_DETAILS_FAILURE =
    'SURGERY: UPDATE_SURGERY_DETAILS_FAILURE';
export const CHECK_DUPLICATE_TEMPLATE_SUCCESS =
    'SURGERY: CHECK_DUPLICATE_TEMPLATE_SUCCESS';
export const CHECK_DUPLICATE_TEMPLATE_FAILURE =
    'SURGERY: CHECK_DUPLICATE_TEMPLATE_FAILURE';
export const CHECK_DUPLICATE_TEMPLATE = 'SURGERY: CHECK_DUPLICATE_TEMPLATE';

export const GET_OUTSIDE_SHIPPING_METHODS_SUCCESS =
    'SHIPPING: GET_OUTSIDE_SHIPPING_METHODS_SUCCESS';
export const GET_OUTSIDE_SHIPPING_METHODS_FAILURE =
    'SHIPPING: GET_OUTSIDE_SHIPPING_METHODS_FAILURE';

export const GET_INSIDE_SHIPPING_METHODS_SUCCESS =
    'SHIPPING: GET_INSIDE_SHIPPING_METHODS_SUCCESS';
export const GET_INSIDE_SHIPPING_METHODS_FAILURE =
    'SHIPPING: GET_INSIDE_SHIPPING_METHODS_FAILURE';
export const GET_PRODUCTS = 'PRODUCTS:GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'PRODUCTS:GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'PRODUCTS:GET_PRODUCTS_FAILURE';
export const GET_PRODUCTS_BULK = 'PRODUCTS:GET_PRODUCTS_BULK';
export const GET_PRODUCTS_BULK_SUCCESS = 'PRODUCTS:GET_PRODUCTS_BULK_SUCCESS';
export const GET_PRODUCTS_BULK_FAILURE = 'PRODUCTS:GET_PRODUCTS_BULK_FAILURE';
export const SET_PRODUCTS = 'PRODUCTS:SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'PRODUCTS:CLEAR_PRODUCTS';
export const GET_PRODUCTSGUIDE = 'PRODUCTSGUIDE:GET_PRODUCTSGUIDE';
export const GET_PRODUCTSGUIDE_SUCCESS =
    'PRODUCTSGUIDE:GET_PRODUCTSGUIDE_SUCCESS';
export const GET_PRODUCTSGUIDE_FAILURE =
    'PRODUCTSGUIDE:GET_PRODUCTSGUIDE_FAILURE';
export const SET_PRODUCTSGUIDE = 'PRODUCTSGUIDE:SET_PRODUCTSGUIDE';
export const CLEAR_PRODUCTS_GUIDE = 'PRODUCTSGUIDE:CLEAR_PRODUCTS_GUIDE';
export const VALIDATE_PRODUCTS = 'PRODUCTS:VALIDATE_PRODUCTS';
export const VALIDATE_PRODUCTS_SUCCESS = 'PRODUCTS:VALIDATE_PRODUCTS_SUCCESS';
export const VALIDATE_PRODUCTS_FAILURE = 'PRODUCTS: VALIDATE_PRODUCTS_FAILURE';
export const CLEAR_VALIDATED_PRODUCTS = 'PRODUCTS: CLEAR_VALIDATED_PRODUCTS';
export const GET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER';
export const GET_PRODUCTSTEMPLATESFILTER_SUCCESS =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_SUCCESS';
export const GET_PRODUCTSTEMPLATESFILTER_FAILURE =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_FAILURE';
export const SET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:SET_PRODUCTSTEMPLATESFILTER';
export const SET_PROGRESS_BAR_STATUS = 'PROGRESSBAR: SET_PROGRESS_BAR_STATUS';
export const RESET_PROGRESS_BAR_STATUS =
    'PROGRESSBAR: RESET_PROGRESS_BAR_STATUS';
export const SET_PROGRESS_BAR_CURRENT_STEP =
    'PROGRESSBAR: SET_PROGRESS_BAR_CURRENT_STEP';
export const SET_PROGRESS_BAR_EDIT_MODE =
    'PROGRESSBAR: SET_PROGRESS_BAR_EDIT_MODE';

export const SET_PRICING_NOTES = 'SET_PRICING_NOTES';
//product details

export const GET_PRODUCT_DETAILS = 'PRODUCTS: GET_PRODUCT_DETAILS';
export const GET_PRODUCT_DETAILS_SUCCESS =
    'PRODUCTS: GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_ERROR = 'PRODUCTS: GET_PRODUCT_DETAILS_ERROR';
export const SORT_PRODUCT_DETAILS = 'PRODUCTS: SORT_PRODUCT_DETAILS';
export const GET_SHIPPING_METHODS = 'SHIPPING: GET_SHIPPING_METHODS';
export const GET_SHIPPING_METHODS_SUCCESS =
    'SHIPPING: GET_SHIPPING_METHODS_SUCCESS';
export const GET_SHIPPING_METHODS_FAILURE =
    'SHIPPING: GET_SHIPPING_METHODS_FAILURE';
export const RESET_SHIP_TO_ADDRESS = 'SHIPPING: RESET_SHIP_TO_ADDRESS';
export const CLEAR_SHIP_TO_SEARCH_RESULTS = 'SHIPPING: CLEAR_SHIP_TO_SEARCH_RESULTS';
export const GET_SHIP_TO_ADDRESS = 'SHIPPING: GET_SHIP_TO_ADDRESS';
export const SET_SHIP_TO_ADDRESS_VALUE = 'SHIPPING: SET_SHIP_TO_ADDRESS_VALUE';
export const GET_SHIP_TO_ADDRESS_SUCCESS =
    'SHIPPING: GET_SHIP_TO_ADDRESS_SUCCESS';
export const GET_SHIP_TO_SEARCH_SUCCESS =
    'SHIPPING: GET_SHIP_TO_SEARCH_SUCCESS';
export const GET_SHIP_TO_ADDRESS_FAILURE =
    'SHIPPING: GET_SHIP_TO_ADDRESS_FAILURE';
export const GET_BATCH_ALLOCATIONS = 'SHIPPING: GET_BATCH_ALLOCATIONS';
export const GET_BATCH_ALLOCATIONS_SUCCESS =
    'SHIPPING: GET_BATCH_ALLOCATIONS_SUCCESS';
export const GET_BATCH_ALLOCATIONS_FAILURE =
    'SHIPPING: GET_BATCH_ALLOCATIONS_FAILURE';

export const SET_VISUALIZATION_INSPECTION =
    'SUBMIT: SET_VISUALIZATION_INSPECTION';
//Surgery Notes
export const HANDLE_SURGERY_NOTES = 'HANDLE_SURGERY_NOTES';
export const GET_SURGERY_DETAILS = 'GET_SURGERY_DETAILS';
export const GET_SURGERY_DETAILS_SUCCESS = 'GET_SURGERY_DETAILS_SUCCESS';
export const GET_SURGERY_DETAILS_FAILURE = 'GET_SURGERY_DETAILS_FAILURE';
export const GET_SCHEDULE_SURGERY_DETAILS = 'GET_SCHEDULE_SURGERY_DETAILS';
export const RESET_SURGERY_DETAILS = 'RESET_SURGERY_DETAILS';
export const RESET_DROPDOWNS = 'RESET_DROPDOWNS';
export const RESET_SURGERY_DETAILS_REDUCER = 'RESET_SURGERY_DETAILS_REDUCER';
export const CHANGE_SHIPPING_SEGMENT_INDEX = 'CHANGE_SHIPPING_SEGMENT_INDEX';
export const CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT =
    'CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT';
export const DISABLE_SURGERY_DATE = 'DISABLE_SURGERY_DATE';
export const NOTES_VISITED = 'NOTES_VISITED';
export const CURRENT_SURGERY_DATE_SELECTED = 'CURRENT_SURGERY_DATE_SELECTED';
export const CHANGE_ACKNOWLEGMENT_VIEW = 'CHANGE_ACKNOWLEGMENT_VIEW';

//category data
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE';
//approach and technology
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE';
export const SET_UNSAVED_CHANGES_POP_UP = 'SS:SET_UNSAVED_CHANGES_POP_UP';
export const SET_SCHEDULE_SURGERY_CU_IN_PROGRESS =
    'SS:SET_SCHEDULE_SURGERY_CU_IN_PROGRESS';
export const PHYSICIAN_LOAD_ALL_LOADING = 'PHYSICIAN_LOAD_ALL_LOADING';
export const SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP =
    'SS:SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP';
export const MAZOR_CASE_COVERAGE_LOADING = 'MAZOR_CASE_COVERAGE_LOADING';

//set recently used PhysicianS
export const PUT_RECENTLY_USED_PHYSICIANS = 'PUT_RECENTLY_USED_PHYSICIANS';
export const PUT_RECENTLY_USED_PHYSICIANS_SUCCESS =
    'PUT_RECENTLY_USED_PHYSICIANS_SUCCESS';
export const PUT_RECENTLY_USED_PHYSICIANS_FAILURE =
    'PUT_RECENTLY_USED_PHYSICIANS_FAILURE';

//get derived territories (non-interventional)
export const GET_DERIVED_TERRITORIES = 'GET_DERIVED_TERRITORIES';
export const SET_DERIVED_TERRITORIES_SUCCESS =
    'SET_DERIVED_TERRITORIES_SUCCESS';
export const SET_DERIVED_TERRITORIES_FAILURE =
    'SET_DERIVED_TERRITORIES_FAILURE';

//get detailed templates list
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST =
    'GET_DETAILED_PRODUCT_TEMPLATE_LIST';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS =
    'GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE =
    'GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE';
export const UPDATE_PRODUCT_TEMPLATE_LIST = 'UPDATE_PRODUCT_TEMPLATE_LIST';

//get template details with template id
export const GET_TEMPLATE_DETAILS = 'GET_TEMPLATE_DETAILS';
export const GET_TEMPLATE_DETAILS_SUCCESS = 'GET_TEMPLATE_DETAILS_SUCCESS';
export const GET_TEMPLATE_DETAILS_FAILURE = 'GET_TEMPLATE_DETAILS_FAILURE';

//create template
export const CREATE_PRODUCT_TEMPLATE = 'CREATE_PRODUCT_TEMPLATE';
export const CREATE_PRODUCT_TEMPLATE_SUCCESS =
    'CREATE_PRODUCT_TEMPLATE_SUCCESS';
export const CREATE_PRODUCT_TEMPLATE_FAILURE =
    'CREATE_PRODUCT_TEMPLATE_FAILURE';

//update product template
export const UPDATE_PRODUCT_TEMPLATE = 'UPDATE_PRODUCT_TEMPLATE';
export const UPDATE_PRODUCT_TEMPLATE_SUCCESS =
    'UPDATE_PRODUCT_TEMPLATE_SUCCESS';
export const UPDATE_PRODUCT_TEMPLATE_FAILURE =
    'UPDATE_PRODUCT_TEMPLATE_FAILURE';
// product template
export const GET_DATA_FOR_PRODUCT_TEMPLATE = 'GET_DATA_FOR_PRODUCT_TEMPLATE';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS =
    'GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE =
    'GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE';

export const RESET_CREATE_TEMPLATE = 'RESET_CREATE_TEMPLATE';

//Update Template filter refine data (listing)
export const SET_PRODUCT_TEMPLATE_REFINE_DATA =
    'SET_PRODUCT_TEMPLATE_REFINE_DATA';
export const SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST =
    'SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST';

export const CLEAR_SPECFIC_DROPDOWN_LIST = 'CLEAR_SPECFIC_DROPDOWN_LIST';
export const GET_HOLIDAY_LIST = 'GET_HOLIDAY_LIST';
export const GET_HOLIDAY_LIST_SUCCESS = 'GET_HOLIDAY_LIST_SUCCESS';
export const SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS =
    'SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS';
export const SET_HOLIDAY_LIST_AND_UPCOMING_BUSINESS_DAYS_FOR_REQUEST_DELIVERY_DATE =
    'SET_HOLIDAY_LIST_AND_UPCOMING_BUSINESS_DAYS_FOR_REQUEST_DELIVERY_DATE';
export const GET_HOLIDAY_LIST_ERROR = 'GET_HOLIDAY_LIST_ERROR';
export const CLEAR_SHIPPING_ADDRESS = 'CLEAR_SHIPPING_ADDRESS';
export const RESET_CREATE_UPDATE_SURGERY = 'RESET_CREATE_UPDATE_SURGERY';
export const SET_EXPANDED_FILTER_VIEW = 'SET_EXPANDED_FILTER_VIEW';
export const SET_SURGERY_DETAILS_GENERIC = 'SET_SURGERY_DETAILS_GENERIC';
export const SET_PAGE_NUM = 'SET_PAGE_NUM';
export const SET_FOOTER_FROM_TRANSFER_SURGERY =
    'SET_FOOTER_FROM_TRANSFER_SURGERY';

export const UPDATE_TEMPLATE_DETAILS = 'UPDATE_TEMPLATE_DETAILS';
export const RESET_BATCH_ALLOCATION = 'RESET_BATCH_ALLOCATION';
export const SET_PRODUCT_TEMPLATE_UID = 'SET_PRODUCT_TEMPLATE_UID';
export const VALIDATE_REPORT_ACCOUNT = 'VALIDATE_REPORT_ACCOUNT';
export const RESET_VALIDATE_REPORT_ACCOUNT = 'RESET_VALIDATE_REPORT_ACCOUNT';
export const VALIDATE_REPORT_ACCOUNT_SUCCESS =
    'VALIDATE_REPORT_ACCOUNT_SUCCESS';
export const VALIDATE_REPORT_ACCOUNT_FAILURE =
    'VALIDATE_REPORT_ACCOUNT_FAILURE';
export const VALIDATE_ACCOUNT = 'SCHEDULE_VALIDATE_ACCOUNT';
export const RESET_VALIDATE_ACCOUNT = 'SCHEDULE_SURGERY:RESET_VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS = 'SCHEDULE_VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNT_FAILURE = 'SCHEDULE_VALIDATE_ACCOUNT_FAILURE';
export const VALIDATE_BILLTO = 'VALIDATE_BILLTO';
export const RESET_VALIDATE_BILLTO = 'RESET_VALIDATE_BILLTO';
export const VALIDATE_BILLTO_SUCCESS = 'VALIDATE_BILLTO_SUCCESS';
export const VALIDATE_BILLTO_FAILURE = 'VALIDATE_BILLTO_FAILURE';
export const CLEAR_CALLTYPE = 'CLEAR_CALLTYPE';
export const SET_UNKNOWN_CHECKBOX = 'SET_UNKNOWN_CHECKBOX';
export const SURGERY_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE =
    'SURGERY_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE';
export const SURGERY_ATTACHMENT_UPLOAD_SUCCESS_TISSUE =
    'SURGERY_ATTACHMENT_UPLOAD_SUCCESS_TISSUE';
export const SURGERY_ATTACHMENT_UPLOAD = 'SURGERY_ATTACHMENT_UPLOAD';
export const SURGERY_ATTACHMENT_UPLOAD_FAILURE =
    'SURGERY_ATTACHMENT_UPLOAD_FAILURE';
export const SURGERY_DELETE_ATTACHMENT_REQUEST =
    'SURGERY_DELETE_ATTACHMENT_REQUEST';
export const SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS =
    'SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS';
export const DELETE_ATTACHMENT_REQUEST_FAILURE =
    'SURGERY_DELETE_ATTACHMENT_REQUEST_FAILURE';
export const GET_IMAGE_PO_PREVIEW = 'SURGERY: GET_IMAGE_PO_PREVIEW';
export const GET_IMAGE_PO_PREVIEW_SUCCESS =
    'SURGERY: GET_IMAGE_PO_PREVIEW_SUCCESS';
export const GET_IMAGE_PO_PREVIEW_FAILURE =
    'SURGERY: GET_IMAGE_PO_PREVIEW_FAILURE';

export const storeAddItemData = (payload) => {
    return {
        type: STORE_ADD_ITEM,
        payload: payload,
    };
};

export const clearAddItem = (payload) => {
    return {
        type: CLEAR_ADD_ITEM,
        payload: payload,
    };
};

export const setSurgeryDetails = (surgeryDetails) => {
    return {
        type: SET_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const setPageNum = (payload) => {
    return {
        type: SET_PAGE_NUM,
        payload: payload,
    };
};
export const checkDuplicateTemplate = (payload) => {
    return {
        type: CHECK_DUPLICATE_TEMPLATE,
        payload: payload,
    };
};

//
export const saveSurgery = (surgeryDetails) => {
    return {
        type: SAVE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const updateSurgery = (surgeryDetails) => {
    return {
        type: UPDATE_SURGERY_DETAILS,
        payload: surgeryDetails,
    };
};

export const setCartData = (cartData) => {
    return {
        type: SET_CART_DATA,
        payload: cartData,
    };
};

export const updateCartData = (operation, productKey, isSet, cfn) => {
    return {
        type: UPDATE_CART_DATA,
        payload: { operation, productKey, isSet, cfn },
    };
};

export const updateCartDataShipping = (
    newFields,
    productKeys,
    isReservationBatch
) => {
    return {
        type: UPDATE_CART_DATA_SHIPPING,
        payload: { newFields, productKeys, isReservationBatch },
    };
};

export const setSurgeryNumber = (numberOfSurgery) => {
    return {
        type: SET_SURGERY_NUMBER,
        payload: numberOfSurgery,
    };
};

export const setShippingDetails = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS,
        payload: shippingDetails,
    };
};

export const setShippingDetailsEditMode = (shippingDetails) => {
    return {
        type: SET_SHIPPING_DETAILS_EDIT_MODE,
        payload: shippingDetails,
    };
};

export const setShippingAddress = (shippingDetails) => {
    return {
        type: SET_SHIPPING_ADDRESS,
        payload: shippingDetails,
    };
};

export const getDropdownValues = (dropDownDetails) => {
    return {
        type: GET_DROPDOWN,
        payload: dropDownDetails,
    };
};
export const setProductsGuide = (productsGuideList, name) => {
    return {
        type: SET_PRODUCTSGUIDE,
        payload: productsGuideList,
        name: name,
    };
};

export const searchProducts = (queryParam) => {
    return {
        type: GET_PRODUCTS,
        payload: queryParam,
    };
};

export const setProductSearchStatus = (status) => {
    return {
        type: SET_PRODUCT_SEARCH_STATUS,
        payload: status,
    };
};


export const searchProductsBulk = (cfns) => {
    return {
        type: GET_PRODUCTS_BULK,
        payload: cfns,
    };
};

export const clearProducts = () => {
    return {
        type: CLEAR_PRODUCTS,
    };
};

export const getProductsGuide = () => {
    return {
        type: GET_PRODUCTSGUIDE,
    };
};

export const sortProductDetails = (data) => {
    return {
        type: SORT_PRODUCT_DETAILS,
        payload: data,
    };
};
export const setProgressBarStatus = (completedStep) => {
    return {
        type: SET_PROGRESS_BAR_STATUS,
        payload: completedStep,
    };
};

export const reSetProgressBarStatus = () => {
    return {
        type: RESET_PROGRESS_BAR_STATUS,
    };
};

export const setProgressBarCurrentStep = (currentStep) => {
    return {
        type: SET_PROGRESS_BAR_CURRENT_STEP,
        payload: currentStep,
    };
};

export const setProgressBarStateEditMode = (data) => {
    return {
        type: SET_PROGRESS_BAR_EDIT_MODE,
        payload: data,
    };
};

export const validateProducts = (products) => {
    return {
        type: VALIDATE_PRODUCTS,
        payload: products,
    };
};

export const clearValidatedProducts = () => {
    return {
        type: CLEAR_VALIDATED_PRODUCTS,
    };
};

export const clearCallType = (data) => {
    return {
        type: CLEAR_CALLTYPE,
        payload: data,
    };
};
export const getProductDetails = (data) => {
    return {
        type: GET_PRODUCT_DETAILS,
        payload: data,
    };
};

export const getProductsTemplatesFilter = () => {
    return {
        type: GET_PRODUCTSTEMPLATESFILTER,
    };
};

export const setProductsTemplatesFilter = (productsTemplatesFilter) => {
    return {
        type: SET_PRODUCTSTEMPLATESFILTER,
        payload: productsTemplatesFilter,
    };
};

export const getShippingMethods = (payload) => {
    return {
        type: GET_SHIPPING_METHODS,
        payload,
    };
};

export const resetShipToAddress = () => {
    return {
        type: RESET_SHIP_TO_ADDRESS,
    };
};

export const clearShipToSearchResults = () => {
    return {
        type: CLEAR_SHIP_TO_SEARCH_RESULTS,
    };
};

export const getShipToAddress = (data) => {
    return {
        type: GET_SHIP_TO_ADDRESS,
        payload: data,
    };
};

export const setShipToAddressValue = (data) => {
    return {
        type: SET_SHIP_TO_ADDRESS_VALUE,
        payload: data,
    };
};

export const getShippingBatchAllocations = (data) => {
    return {
        type: GET_BATCH_ALLOCATIONS,
        payload: data,
    };
};
export const handleSurgeryNotes = (data) => {
    return {
        type: HANDLE_SURGERY_NOTES,
        payload: data,
    };
};
export const setPricingNotes = (data) => {
    return {
        type: SET_PRICING_NOTES,
        payload: data,
    };
};
export const setVisualizationInspection = (value) => {
    return {
        type: SET_VISUALIZATION_INSPECTION,
        payload: value,
    };
};
export const getSurgeryDetails = (
    myCaseRef,
    updateState,
    isTransferSurgery = false,
    isUnidPostpone = false
) => {
    return {
        type: GET_SURGERY_DETAILS,
        payload: { myCaseRef, updateState, isTransferSurgery, isUnidPostpone },
    };
};

export const clearTemplateProducts = () => {
    return {
        type: CLEAR_TEMPLATE_PRODUCTS,
    };
};

// export const getScheduleSurgeryDetails = (
//     type,
//     myCaseRef,
//     StatusCode,
//     statusMessage
// ) => {
//     return {
//         type: GET_SCHEDULE_SURGERY_DETAILS,
//         payload: {type, myCaseRef, StatusCode, statusMessage}
//     };
// };

export const getScheduleSurgeryDetails = (param) => {
    return {
        type: GET_SCHEDULE_SURGERY_DETAILS,
        payload: param,
    };
};

export const resetSurgeryDetails = () => {
    return {
        type: RESET_SURGERY_DETAILS,
        payload: '',
    };
};
export const resetDropdown = () => {
    return {
        type: RESET_DROPDOWNS,
        payload: '',
    };
};
export const changeShippingSegmentIndex = (index) => {
    return {
        type: CHANGE_SHIPPING_SEGMENT_INDEX,
        payload: index,
    };
};
export const changeAcknowlegmentCheckbox = (data) => {
    return {
        type: CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT,
        payload: data,
    };
};
export const changeAcknowlegmentView = (data) => {
    return {
        type: CHANGE_ACKNOWLEGMENT_VIEW,
        payload: data,
    };
};
export const disableSurgeryDate = (value) => {
    return {
        type: DISABLE_SURGERY_DATE,
        payload: value,
    };
};
export const isNotesVisited = (value) => {
    return {
        type: NOTES_VISITED,
        payload: value,
    };
};
export const currentSurgeryDateSelected = (value) => {
    return {
        type: CURRENT_SURGERY_DATE_SELECTED,
        payload: value,
    };
};

export const getProductsCategoryAndBrands = (data) => {
    return {
        type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
        payload: data,
    };
};

export const getProductsByBrandOrSuperCategory = (data) => {
    return {
        type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        payload: data,
    };
};

export const setScheduleSurgeryUnsavedChangesPopUp = (value) => {
    return {
        type: SET_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};
export const setScheduleSurgeryCUInProgress = (value) => {
    return {
        type: SET_SCHEDULE_SURGERY_CU_IN_PROGRESS,
        payload: value,
    };
};
export const loadAllPhyscianLoading = (data) => {
    return {
        type: PHYSICIAN_LOAD_ALL_LOADING,
        payload: data,
    };
};
export const loadAllCaseCoverageLoading = (data) => {
    return {
        type: MAZOR_CASE_COVERAGE_LOADING,
        payload: data,
    };
};
export const putRecentlyUsedPhysicians = () => {
    return {
        type: PUT_RECENTLY_USED_PHYSICIANS,
    };
};
export const setRoutePathForSSUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const getDerivedTerritories = (value) => {
    return {
        type: GET_DERIVED_TERRITORIES,
        payload: value,
    };
};

export const getDetailedProductTemplateList = (params) => {
    return {
        type: GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        payload: params,
    };
};

export const updateTemplateDetails = (params) => {
    return {
        type: UPDATE_TEMPLATE_DETAILS,
        payload: params,
    };
};

export const updateDetailedProductTemplateList = (params) => ({
    type: UPDATE_PRODUCT_TEMPLATE_LIST,
    payload: params,
});

export const getTemplateDetails = (params, tempcategory) => {
    return {
        type: GET_TEMPLATE_DETAILS,
        payload: params,
        templatecategory: tempcategory,
    };
};

export const createTemplate = (params) => {
    return {
        type: CREATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const resetCreateTemplate = () => {
    return {
        type: RESET_CREATE_TEMPLATE,
    };
};

export const updateProductTemplate = (params) => {
    return {
        type: UPDATE_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const getRequiredDataFromOrder = (params) => {
    return {
        type: GET_DATA_FOR_PRODUCT_TEMPLATE,
        payload: params,
    };
};

export const clearSingleDropDownList = (value) => {
    return {
        type: CLEAR_SPECFIC_DROPDOWN_LIST,
        payload: value,
    };
};
export const getHolidayList = (data) => {
    return {
        type: GET_HOLIDAY_LIST,
        payload: data,
    };
};
export const clearShippingAddress = (data) => {
    return {
        type: CLEAR_SHIPPING_ADDRESS,
        payload: data,
    };
};
export const clearShippingMethods = (data) => {
    return {
        type: CLEAR_SHIPPING_ADDRESS,
        payload: data,
    };
};
export const resetCreateOrUpdateSurgery = () => {
    return {
        type: RESET_CREATE_UPDATE_SURGERY,
    };
};

export const setExpandedFilters = (data) => {
    return {
        type: SET_EXPANDED_FILTER_VIEW,
        payload: data,
    };
};

export const clearProductsGuide = () => {
    return {
        type: CLEAR_PRODUCTS_GUIDE,
    };
};

export const setSurgeryDetailsGeneric = (data) => {
    return {
        type: SET_SURGERY_DETAILS_GENERIC,
        payload: data,
    };
};

export const setFooterFromTransferSurgery = (data) => {
    return {
        type: SET_FOOTER_FROM_TRANSFER_SURGERY,
        payload: data,
    };
};
export const setProductTemplateUID = (data) => {
    return {
        type: SET_PRODUCT_TEMPLATE_UID,
        payload: data,
    };
};

export const getValidateReportAccountDetails = (params) => {
    return {
        type: VALIDATE_REPORT_ACCOUNT,
        payload: params,
    };
};

export const resetValidateReportAccountDetails = () => {
    return {
        type: RESET_REPORT_VALIDATE_ACCOUNT,
    };
};

export const getValidateAccountDetails = (params) => {
    return {
        type: VALIDATE_ACCOUNT,
        payload: params,
    };
};

export const resetValidateAccountDetails = () => {
    return {
        type: RESET_VALIDATE_ACCOUNT,
    };
};

export const getValidateBillToDetails = (params) => {
    return {
        type: VALIDATE_BILLTO,
        payload: params,
    };
};

export const resetValidateBillToDetails = () => {
    return {
        type: RESET_VALIDATE_BILLTO,
    };
};
export const resetBatchAllocation = () => {
    return {
        type: RESET_BATCH_ALLOCATION,
    };
};

export const setUnknownCheckbox = (data) => {
    return {
        type: SET_UNKNOWN_CHECKBOX,
        payload: data,
    };
};

export const resetSurgeryDetailsReducer = () => {
    return {
        type: RESET_SURGERY_DETAILS_REDUCER,
        payload: '',
    };
};

//ADD PO;

export const resetPoDetails = () => ({
    type: SURGERY_RESET_PO_ATTACHMENT,
    payload: '',
});

// export const setPOTissueImageDetails = (data) => {
//     return {
//         type: SCHEDULE_SURGERY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
//         payload: data,
//     };
// };

export const setPOTissueImageDetails = (data) => {
    return {
        type: SURGERY_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
        payload: data,
    };
};

export const setPONonTissueImageDetails = (data) => {
    return {
        type: SURGERY_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
        payload: data,
    };
};

export const surgeryAttachmentUpload = (formData) => ({
    type: SURGERY_ATTACHMENT_UPLOAD,
    payload: formData,
});

export const deleteAttachmentRequest = (id) => ({
    type: SURGERY_DELETE_ATTACHMENT_REQUEST,
    payload: id,
});

export const getPoImagePreview = (details) => {
    return {
        type: GET_IMAGE_PO_PREVIEW,
        payload: details,
    };
};

export const checkProductBomDetails = (details) => ({
    type: CHECK_PRODUCT_BOM,
    payload: details,
});

export const resetBomData = () => ({
    type: RESET_BOM_DATA,
});

export const deleteProductBom = (details) => ({
    type: DELETE_PRODUCT_BOM,
    payload: details,
});

export const setItemListClicked = (flag) => ({
    type: SET_ITEM_LIST_CLICKED,
    payload: flag,
});

export const setImplantableAndInstrumentProducts = (data) => ({
    type: SET_IMPLANT_AND_INSTRUMENT_PRODUCTS,
    payload: data,
});

export const getTransferRecipientMethods = (payload) => {
    return {
        type: GET_TRANSFER_RECIPIENT_METHODS,
        payload,
    };
};

export const clearTransferRecipients = (data) => {
    return {
        type: CLEAR_TRANSFER_RECIPIENTS,
    };
};

export const clearError = () => {
    return {
        type: CLEAR_ERROR,
    };
};

